export const STREAM_IDLE_TIMEOUT_MS = 90_000;

export type IdleAwareReadResult<T> = ReadableStreamReadResult<T> | "idle";

export async function readWithIdleTimeout<T>(
  reader: ReadableStreamDefaultReader<T>,
  timeoutMs: number,
): Promise<IdleAwareReadResult<T>> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const idle = new Promise<"idle">(resolve => {
    timer = setTimeout(() => resolve("idle"), timeoutMs);
  });
  try {
    return await Promise.race([reader.read(), idle]);
  } finally {
    clearTimeout(timer);
  }
}
